import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { get } from "../../../utils/api";
import { getFinancialYearLabels, fetchYearFromBrsrList } from "../../../utils/brsrFinancialYearLabels";

const appendYear = (label, year) => (year ? `${label} (${year})` : label);

const useReportingYearLabels = () => {
  const { id } = useParams();
  const [reportingFinancialYear, setReportingFinancialYear] = useState("");

  useEffect(() => {
    if (!id) return;
    fetchYearFromBrsrList(get, id).then(setReportingFinancialYear);
  }, [id]);

  const { currentYear, previousYear } =
    getFinancialYearLabels(reportingFinancialYear);

  return {
    currentYear,
    previousYear,
    currentLabel: (label) => appendYear(label, currentYear),
    previousLabel: (label) => appendYear(label, previousYear),
  };
};

export default useReportingYearLabels;
